<template>
  <div>
    <base-header type="instore" :class="['pb-6', 'pb-8', 'pt-5', 'pt-md-8', currentProfile == 'eod_monitoring_dashboards' ? 'eod-sales-header' : '']">

      <!-- Card stats -->
      <div v-if="currentProfile == 'pos_sales_dashboards'" class="row">
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Completed" type="gradient-green" :sub-title="completedStats" icon="fa fa-signal"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Success Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Pending" type="gradient-yellow" :sub-title="unprocessedStats" icon="fa fa-plug"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Unprocessed Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Error" type="gradient-red" :sub-title="errorStats" icon="fa fa-chart-line"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Errors Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Status" type="gradient-blue" :sub-title="invoiceStatus" icon="ni ni-money-coins"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Last Run: {{ lastRun }} </span>
              </template>
            </stats-card>
          </a-spin>
        </div>
      </div>

      <div v-else-if="currentProfile == 'eod_monitoring_dashboards'" class="row">
        <template v-if="eodDashboardMode == 'classic'">
          <div class="col-xl-3 col-lg-6">
            <a-spin :spinning="loadingPOSSalesDashboard">
              <stats-card title="PENDING" type="gradient-orange" :sub-title="pendingStats" icon="fa fa-solid fa-hourglass-half"
                class="mb-4 mb-xl-0">
                <template slot="footer">
                  <span class="mr-2"> Pending Terminals </span>
                  <br><br>
                </template>
              </stats-card>
            </a-spin>
          </div>
          <div class="col-xl-3 col-lg-6">
            <a-spin :spinning="loadingPOSSalesDashboard">
              <stats-card title="COMPLETED" type="gradient-green" :sub-title="completedStats" icon="fa fa-solid fa-clipboard-check"
                class="mb-4 mb-xl-0">
                <template slot="footer">
                  <span class="mr-2"> Completed Terminals </span>
                  <br><br>
                </template>
              </stats-card>
            </a-spin>
          </div>
          <div class="col-xl-3 col-lg-6">
            <a-spin :spinning="loadingPOSSalesDashboard">
              <stats-card title="DISCREPANCY" type="gradient-red" :sub-title="errorStats" icon="fa fa-solid fa-circle-xmark"
                class="mb-4 mb-xl-0">
                <template slot="footer">
                  <span class="mr-2"> Terminals with Discrepancies </span>
                  <br><br>
                </template>
              </stats-card>
            </a-spin>
          </div>
          <div class="col-xl-3 col-lg-6">
            <a-spin :spinning="loadingPOSSalesDashboard">
              <stats-card class="mb-4 mb-xl-0 eod-progress-card" style="background:#2b2b2b; color: white;" type="gradient-blue" sub-title="-" icon="fa fa-solid fa-chart-pie">
                <span class="card-title text-uppercase mb-0 h5 eod-progress-title">OVERALL PROGRESS</span>
                <br />
                <a-progress
                  :percent="progressPercent"
                  status="active"
                  :strokeWidth="25"
                  stroke-color="#d9d9d9"
                  stroke-linecap="square"
                />
                <template slot="footer">
                  <span class="mr-2 eod-progress-footer"> Total Terminals / Completed Terminals </span>
                  <br>
                </template>
              </stats-card>
            </a-spin>
          </div>
        </template>
        <template v-else>
          <div class="col-12">
            <div class="row eod-summary-top-row">
              <div class="col-xl-6 col-lg-12">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-hero-summary">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start flex-wrap mb-4">
                        <div class="eod-hero-heading">
                          <span class="eod-stat-overline">EOD Coverage</span>
                          <h2 class="mb-2">{{ progressPercent }}%</h2>
                          <p class="mb-0 eod-hero-copy">{{ eodSummary.completed_count || 0 }} of {{ eodSummary.total_terminal_count || 0 }} terminals reconciled</p>
                        </div>
                        <div class="eod-hero-chip">
                          <span>Needs Review</span>
                          <strong>{{ eodSummary.discrepancy_count || 0 }}</strong>
                        </div>
                      </div>
                      <a-progress
                        :percent="progressPercent"
                        status="active"
                        :strokeWidth="18"
                        stroke-color="#f8fafc"
                        stroke-linecap="square"
                      />
                      <div class="eod-hero-pills mt-4">
                        <div class="eod-hero-pill">
                          <span>Active Terminals</span>
                          <strong>{{ eodSummary.total_terminal_count || 0 }}</strong>
                        </div>
                        <div class="eod-hero-pill">
                          <span>Completed</span>
                          <strong>{{ eodSummary.completed_count || 0 }}</strong>
                        </div>
                        <div class="eod-hero-pill">
                          <span>Open Items</span>
                          <strong>{{ eodSummary.discrepancy_count || 0 }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-spin>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-stat-card eod-top-stat-card is-pending-card">
                    <div class="card-body">
                      <div class="eod-stat-icon"><i class="fa fa-solid fa-hourglass-half"></i></div>
                      <span class="eod-stat-overline">Pending Z-read</span>
                      <h2>{{ eodSummary.pending_zread_count || 0 }}</h2>
                      <p class="eod-stat-copy">No submitted Z-reading yet for the selected business date.</p>
                    </div>
                  </div>
                </a-spin>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-stat-card eod-top-stat-card is-complete-card">
                    <div class="card-body">
                      <div class="eod-stat-icon"><i class="fa fa-solid fa-clipboard-check"></i></div>
                      <span class="eod-stat-overline">Fully Reconciled</span>
                      <h2>{{ eodSummary.completed_count || 0 }}</h2>
                      <p class="eod-stat-copy">Count, gross, and net sales all line up for the day.</p>
                    </div>
                  </div>
                </a-spin>
              </div>
            </div>
            <div class="row eod-summary-bottom-row">
              <div class="col-xl-4 col-lg-4 col-md-6">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-stat-card is-count-card">
                    <div class="card-body">
                      <div class="eod-stat-icon"><i class="fa fa-solid fa-list-ol"></i></div>
                      <span class="eod-stat-overline">Count Issues</span>
                      <h2>{{ eodSummary.count_issue_count || 0 }}</h2>
                      <p class="eod-stat-copy">Transaction completeness breaks between Z-read and POS documents.</p>
                    </div>
                  </div>
                </a-spin>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-stat-card is-gross-card">
                    <div class="card-body">
                      <div class="eod-stat-icon"><i class="fa fa-solid fa-coins"></i></div>
                      <span class="eod-stat-overline">Gross Issues</span>
                      <h2>{{ eodSummary.gross_issue_count || 0 }}</h2>
                      <p class="eod-stat-copy">Gross sales do not reconcile between Z-read and POS documents.</p>
                    </div>
                  </div>
                </a-spin>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6">
                <a-spin :spinning="loadingPOSSalesDashboard">
                  <div class="card border-0 shadow-sm mb-4 eod-stat-card is-net-card">
                    <div class="card-body">
                      <div class="eod-stat-icon"><i class="fa fa-solid fa-scale-balanced"></i></div>
                      <span class="eod-stat-overline">Net Issues</span>
                      <h2>{{ eodSummary.net_issue_count || 0 }}</h2>
                      <p class="eod-stat-copy">Net sales still need investigation for the selected date.</p>
                    </div>
                  </div>
                </a-spin>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-else-if="currentProfile == 'terminal_full_sync_details'" class="row">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Counter" type="gradient-green" :sub-title="fullSyncCounter" icon="fa fa-signal"
            class="mb-4 mb-xl-0">
            <template slot="footer">
              <span class="mr-2"> Server Full Sync Counter </span>
              <br><br>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-lg-6">
          <stats-card title="Timestamp" type="gradient-green" :sub-title="fullSyncTimestamp" icon="fa fa-clock"
            class="mb-4 mb-xl-0">
            <template slot="footer">
              <span class="mr-2"> Server Full Sync Timestamp </span>
              <br><br>
            </template>
          </stats-card>
        </div>
      </div>

      <br><br>
      <div v-if="activeModules.length > 0">
        <base-dropdown>
          <base-button slot="title" type="success" class="dropdown-toggle">
            Barter Tools - {{ _.startCase(currentProfile) }}
          </base-button>
          <a v-for="profile in activeModules" :key="profile.id"
            @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item"
            href="#">{{ profile.name }}</a>
        </base-dropdown>
        <base-button v-if="currentProfile == 'pos_sales_dashboards'" type="success" class="refresh-pos-data-btn"
          @click.prevent="loadPOSSalesDashboard">
          <label>
            <a-icon type="reload" />
          </label>
        </base-button>
        <!-- <div v-if="currentProfile == 'eod_monitoring_dashboards'" class="eod-mode-switch">
          <span class="eod-mode-label">Mode</span>
          <a-radio-group :value="eodDashboardMode" button-style="solid" size="small" @change="onEodDashboardModeChange" disabled>
            <a-radio-button value="classic">Classic</a-radio-button>
            <a-radio-button value="new">New</a-radio-button>
          </a-radio-group>
        </div> -->
      </div>
      <base-dropdown v-else>
        <base-button slot="title" type="success" class="dropdown-toggle">
          Barter Tools
        </base-button>
        <a class="dropdown-item" disabled>No active module/s under this feature</a>
        <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a> -->
      </base-dropdown>
      <!-- <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Tools - {{ _.startCase(currentProfile)}}
                </base-button>
                    <a @click.prevent="setCurrentProfile('pos_sessions')" class="dropdown-item" href="#">POS Sessions</a>
                    <a @click.prevent="setCurrentProfile('api_invoices')" class="dropdown-item" href="#">Api Invoices</a>
                    <a @click.prevent="setCurrentProfile('terminal_full_sync_details')" v-if="serverType == 'branch'"  class="dropdown-item" href="#">Terminal Full Sync Details</a>
                    <a @click.prevent="setCurrentProfile('terminal_delta_sync_details')" v-if="serverType == 'branch'" class="dropdown-item" href="#">Terminal Delta Sync Details</a>
                    <a @click.prevent="setCurrentProfile('branch_delta_sync_details')" v-if="serverType == 'ho'" class="dropdown-item" href="#">Branch Delta Sync Details</a>
            </base-dropdown> -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="mb-3 card" style="height: 70vh; overflow: scroll;">
            <div v-if="currentProfile == 'pos_sales_dashboards'" class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body" v-if="accessRights.includes('V')">
                  <div class="filter-bar ui basic segment grid">
                    <div class="ui form">
                      <div class="inline field">
                        <h6 class="heading-small text-muted mb-4">Search</h6>
                        <div class="input-group">
                          <div class="input-group-append">
                            <base-input alternative="" label="Business Date">
                              <br>
                              <a-date-picker :defaultValue="moment()" v-model="inputBusinessDate" :format="dateFormat" @change="formatDate" />
                            </base-input>
                          </div>
                        </div>
                        <div class="input-group ">
                          <div class="input-group-append">
                            <base-input alternative="" label="Site" inputClasses="w-100">
                              <a-select v-model="filters.siteId" @change="fetchTerminals" class="w-100" :disabled="isBranch">
                                <a-select-option key="0" value="0">All Sites</a-select-option>
                                <a-select-option v-for="site in sites" :key="site.code" :value="site.id">
                                  {{ site.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>
                        <div class="input-group ">
                          <div class="input-group-append">
                            <base-input alternative="" label="Terminal">
                              <a-select v-model="filters.terminalId"  class="w-100" >
                                <a-select-option key="0" value="0">All Terminals</a-select-option>
                                <a-select-option v-for="terminal in terminals" :key="terminal.code" :value="terminal.id">
                                  {{ terminal.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>

                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                        <div>
                          <base-radio name="0" class="mb-3" v-model="filters.status" value="O">
                            All
                          </base-radio>
                          <base-radio name="C" class="mb-3" v-model="filters.status" value="C">
                            Completed
                          </base-radio>
                          <base-radio name="E" class="mb-3" v-model="filters.status" value="E">
                            Error
                          </base-radio>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body" v-if="accessRights.includes('V')">
                  <api-invoices-table v-if="currentProfile == 'pos_sales_dashboards'"></api-invoices-table>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>
            </div>

            <div v-else-if="currentProfile == 'eod_monitoring_dashboards'" :class="eodDashboardMode == 'classic' ? 'row no-gutters' : 'no-gutters'">
              <template v-if="eodDashboardMode == 'classic'">
                <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                  <div class="card-body" v-if="accessRights.includes('V')">
                    <div class="filter-bar ui basic segment grid">
                      <div class="ui form">
                        <div class="inline field">
                          <h6 class="heading-small text-muted mb-4">Search</h6>
                          <div class="input-group">
                            <div class="input-group-append">
                              <base-input alternative="" label="Business Date">
                                <br>
                                <a-date-picker :defaultValue="moment()" v-model="inputBusinessDate" :format="dateFormat" @change="formatDate" />
                              </base-input>
                            </div>
                          </div>
                          <div class="input-group ">
                            <div class="input-group-append">
                              <base-input alternative="" label="Site" inputClasses="w-100">
                                <a-select v-model="filters.siteId" @change="fetchTerminals" class="w-100" :disabled="isBranch">
                                  <a-select-option key="0" value="0">All Sites</a-select-option>
                                  <a-select-option v-for="site in sites" :key="site.code" :value="site.id">
                                    {{ site.name }}</a-select-option>
                                </a-select>
                              </base-input>
                            </div>
                          </div>
                          <div class="input-group ">
                            <div class="input-group-append">
                              <base-input alternative="" label="Terminal">
                                <a-select v-model="filters.terminalId" class="w-100" mode="multiple">
                                  <a-select-option v-for="terminal in terminals" :key="terminal.code" :value="terminal.id">
                                    {{ terminal.name }}</a-select-option>
                                </a-select>
                              </base-input>
                            </div>
                          </div>

                          <hr class="my-4" />
                          <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                          <div>
                            <base-radio name="0" class="mb-3" v-model="filters.status" value="O">
                              All
                            </base-radio>
                            <base-radio name="C" class="mb-3" v-model="filters.status" value="C">
                              Completed
                            </base-radio>
                            <base-radio name="P" class="mb-3" v-model="filters.status" value="P">
                              Pending
                            </base-radio>
                            <base-radio name="E" class="mb-3" v-model="filters.status" value="E">
                              Mismatch
                            </base-radio>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body" v-else>
                    <a-empty class='mt-5' :image-style="{ height: '50px', }">
                      <span slot="description"> No access </span>
                    </a-empty>
                  </div>
                </div>

                <div class="col-md-9">
                  <div class="card-body" v-if="accessRights.includes('V')">
                    <eod-monitoring-table></eod-monitoring-table>
                  </div>
                  <div class="card-body" v-else>
                    <a-empty class='mt-5' :image-style="{ height: '50px', }">
                      <span slot="description"> No access </span>
                    </a-empty>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-md-12">
                  <div class="card-body" v-if="accessRights.includes('V')">
                    <eod-monitoring-table-new
                      :end-point="endPoint"
                      :filters="filters"
                      :summary="eodSummary"
                      :sites="sites"
                      :terminals="terminals"
                      :is-branch="isBranch"
                      :loading-summary="loadingPOSSalesDashboard"
                      @apply-filters="applyNewEodFilters"
                      @site-change="handleNewEodSiteChange"
                    />
                  </div>
                  <div class="card-body" v-else>
                    <a-empty class='mt-5' :image-style="{ height: '50px', }">
                      <span slot="description"> No access </span>
                    </a-empty>
                  </div>
                </div>
              </template>
            </div>

            <!-- <div v-else-if="(currentProfile=='terminal_full_sync_details'" ||  currentProfile=='terminal_delta_sync_details') && serverType == 'branch' " class="row no-gutters"> -->
            <div
              v-else-if="(currentProfile == 'terminal_full_sync_details' || currentProfile == 'terminal_delta_sync_details')"
              class="row no-gutters">
              <div class="col-md-12" v-if="accessRights.includes('V')">
                <div class="card-body">
                  <terminal-full-sync-details-table v-if="currentProfile == 'terminal_full_sync_details'">
                  </terminal-full-sync-details-table>
                  <terminal-delta-sync-details-table v-else-if="currentProfile == 'terminal_delta_sync_details'">
                  </terminal-delta-sync-details-table>
                </div>
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'branch_delta_sync_details')" class="no-gutters">
              <div class="card-body" v-if="accessRights.includes('V')">
                <branch-delta-sync-details-table v-if="currentProfile == 'branch_delta_sync_details'"
                  :key="componentKey"></branch-delta-sync-details-table>
              </div>
              <div class="card-body" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'offline_tools')" class="no-gutters">
              <offline-tool v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'cash_movements')" class="no-gutters">
              <cash-movement v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'job_monitorings')" class="no-gutters">
              <jobs-table v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else class="row no-gutters">
              <div class="card-body" v-if="accessRights.includes('V')">
                <pos-sessions-table v-if="currentProfile == 'pos_declarations'" :accessRights="accessRights"
                  :key="componentKey"></pos-sessions-table>
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfflineTool from './Tools/OfflineTool.vue'
import CashMovement from './Tools/CashMovement.vue'
import PosSessionsTable from './Tables/PosSessionsTable.vue'
import ApiInvoicesTable from './Tables/ApiInvoicesTable.vue'
import EodMonitoringTable from './Tables/EodMonitoringTable.vue'
import EodMonitoringTableNew from './Tables/EodMonitoringTableNew.vue'
import TerminalFullSyncDetailsTable from './Tables/TerminalFullSyncDetailsTable.vue'
import TerminalDeltaSyncDetailsTable from './Tables/TerminalDeltaSyncDetailsTable.vue'
import BranchDeltaSyncDetailsTable from './Tables/BranchDeltaSyncDetailsTable.vue'
import JobsTable from './Jobs.vue'

import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from './../controllers/secureStorage';
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment';

export default {
  data() {
    return {
      searchFilter: "DATE(businessDate)",
      sessionStats: "0",
      filterStatus: "0",
      inputProfile: '',
      filterSyncStatus: "0",
      dateFormat: 'MM-DD-YYYY',
      inputBusinessDate: moment(),
      formatBusinessDate: moment().format('YYYY-MM-DD'),
      completedStats: "0",
      fullSyncCounter: '',
      fullSyncTimestamp: '',
      unprocessedStats: "0",
      pendingStats: "0",
      progressPercent: 0,
      errorStats: "0",
      invoiceStatus: "Stopped",
      lastRun: "",
      activeModules: [],
      accessRights: [],
      profId: null,
      componentKey: 0,
      formKey: 0,
      loadingPOSSalesDashboard: false,
      eodDashboardMode: 'new',
      eodDashboardSettingId: null,
      eodSummary: {},
      sites: [],
      terminals: [],
      filters: {
        businessDate: '',
        siteId: secureStorage.getItem("defaultSiteId"),
        terminalId: '0',
        status: '0',
        issueFilter: '',
        mismatchOnly: false,
      },
      isBranch: secureStorage.getItem("currentSiteSiteType") == 'branch' ? true : false
    }
  },
  mounted: async function () {
    // siteType = secureStorage.getItem("currentSiteSiteType");
    // isBranch = secureStorage.getItem("currentSiteSiteType") == 'branch' ? true : false;
    // console.log("site id: " + secureStorage.getItem("defaultSiteId"));

    var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=P-002', null, null)
    var toolModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
    this.activeModules = toolModules.filter(module => !this.isEodMonitoringModule(module))

    if (this.currentProfile == "eod_monitoring_dashboards") {
      this.$router.replace('/eod_monitoring_dashboard')
      return
    }

    if (this.activeModules.length > 0) {
      // if(this.currentProfile != 'pos_sales_dashboards' && this.currentProfile != 'terminal_delta_sync_details' && this.currentProfile != 'branch_delta_sync_details'){
      var profile = _.snakeCase(this.activeModules[0].name)
      this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
      // }
    } else {
      this.setCurrentProfile(null, null);
    }

    if (this.currentProfile == "pos_sales_dashboards") {
      this.loadPOSSalesDashboard();
      // this.formatBusinessDate = null
      // if (this.inputBusinessDate != null) {
      //     this.formatBusinessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')
      // } else {
      //     this.formatBusinessDate = moment().format('YYYY-MM-DD')
      // }

      // var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.formatBusinessDate , null)
      // this.completedStats =  '' + stats["no_of_completed"] + '';
      // this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
      // this.errorStats = '' + stats["no_of_error"] + '';
      // this.invoiceStatus = stats["invoice_status"];
      // this.lastRun = moment(stats["last_run"]);
      // this.setProfileId(stats["setting_id"]);

      // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)
    }else if (this.currentProfile == "terminal_full_sync_details") {
      var full_sync_detail = await HTTPRequest.getRequest(this.endPoint + "terminal_full_sync_details/server_full_sync_detail", null)
      this.fullSyncCounter = full_sync_detail.server_full_sync_counter.toString()
      this.fullSyncTimestamp = full_sync_detail.server_full_sync_timestamp
    }

  },
  watch: {
    filters: {
      handler() {
        this.changeFilter(this.filters);
      },
      deep: true
    },
    filterSyncStatus: function () {
      if (this.currentProfile == "branch_delta_sync_details") {
        this.changeSyncFilter(this.filterSyncStatus, 'profile', this.inputProfile)
      } else {
        this.changeSyncFilter(this.filterSyncStatus, 'code', this.inputTerminalName)
      }
    },
    currentProfile: async function () {
      if (this.currentProfile == "eod_monitoring_dashboards") {
        this.$router.replace('/eod_monitoring_dashboard')
        return
      }
      if (this.currentProfile == "pos_sales_dashboards") {
        this.loadPOSSalesDashboard();
        // this.formatBusinessDate = null
        // if (this.inputBusinessDate != null) {
        //     this.formatBusinessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')
        // }
        // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)

        // var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.formatBusinessDate , null)
        // this.completedStats =  '' + stats["no_of_completed"] + '';
        // this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
        // this.errorStats = '' + stats["no_of_error"] + '';
        // this.invoiceStatus = stats["invoice_status"];
        // this.lastRun = moment(stats["last_run"]);
        // this.setProfileId(stats["setting_id"]);
      } else if (this.currentProfile == "eod_monitoring_dashboards"){
        await this.loadEodDashboardPreference();
        this.sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
        await this.fetchTerminals(this.filters.siteId);
        this.formatDate();
        this.changeFilter(this.filters);
      }else if (this.currentProfile == "terminal_full_sync_details") {
        var full_sync_detail = await HTTPRequest.getRequest(this.endPoint + "terminal_full_sync_details/server_full_sync_detail", null)
        this.fullSyncCounter = full_sync_detail.server_full_sync_counter.toString()
        this.fullSyncTimestamp = full_sync_detail.server_full_sync_timestamp
      }
    },
    parameters: async function () {
      if (this.currentProfile == "pos_sales_dashboards") {
        await this.fetchPosSalesStats();
      } else if (this.currentProfile == "eod_monitoring_dashboards") {
        this.loadEodMonitoringDashboard();
      }
    }
  },
  computed: {
    ...mapState(['currentProfile', 'parameters', 'serverType', 'endPoint', 'profileId'])
  },
  components: {
    JobsTable, CashMovement, PosSessionsTable, ApiInvoicesTable, TerminalFullSyncDetailsTable, TerminalDeltaSyncDetailsTable, BranchDeltaSyncDetailsTable, OfflineTool, EodMonitoringTable, EodMonitoringTableNew
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    moment,
    isEodMonitoringModule(module) {
      const profile = _.pluralize(_.snakeCase(module.name || ''))
      return profile == 'eod_monitoring_dashboards'
    },
    async setCurrentProfile(profile, id) {
      if (profile == 'eod_monitoring_dashboards') {
        this.updateCurrentProfile(profile);
        this.$router.replace('/eod_monitoring_dashboard')
        return
      }
      this.updateCurrentProfile(profile);
      this.inputTerminalName = null;
      this.inputBusinessDate = moment();
      this.filters.status = ['eod_monitoring_dashboards', 'pos_sales_dashboards'].includes(profile) ? 'O' : '0'
      this.filters.terminalId = profile == 'eod_monitoring_dashboards' ? [] : '0'
      this.filters.issueFilter = ''
      this.filters.mismatchOnly = false
      this.filterSyncStatus = "0"

      this.profId = id
      var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id]
      } else {
        this.accessRights = []
      }

      this.componentKey++;
      this.formKey++;

      // console.log(profile);
      // console.log("---------------")
      // console.log(this.accessRights)

    },
    setProfileId(id) {
      this.updateProfileId(id)
    },
    changeFilter(filters) {
      let paramText = '';
      const appendParam = (key, value) => {
        if (value === undefined || value === null || value === '' || value === '0' || value === 'O') return;
        paramText += paramText.length ? '&' : '?';
        paramText += `${key}=${value}`;
      };

      if (this.currentProfile == 'eod_monitoring_dashboards') {
        appendParam('business_date', filters.businessDate);
        appendParam('site_id', filters.siteId);

        if (Array.isArray(filters.terminalId) && filters.terminalId.length > 0) {
          appendParam('terminal_id', filters.terminalId.join(','));
        }

        appendParam('status_filter', filters.status);
      } else {
        for (const filter in filters) {
          if (filters[filter] && filters[filter] !== '0') {
            paramText += paramText.length ? '&' : '?';
            switch (filter) {
              case 'businessDate':
                paramText += `DATE(business_date)=${filters[filter]}`
                break;

              default:
                paramText += `${_.snakeCase(filter)}=${filters[filter]}`
                break;
            }
          }
        }
      }

      this.updateParameters(paramText);
    },
    buildPosSalesStatsUrl() {
      const params = ['status_context=pos_sales_dashboard'];

      if (this.filters.businessDate) {
        params.push(`business_date=${this.filters.businessDate}`);
      }
      if (this.filters.siteId && this.filters.siteId !== '0') {
        params.push(`site_id=${this.filters.siteId}`);
      }
      if (this.filters.terminalId && this.filters.terminalId !== '0') {
        params.push(`terminal_id=${this.filters.terminalId}`);
      }

      return `${this.endPoint}api_invoices/get_stats?${params.join('&')}`;
    },
    async fetchPosSalesStats() {
      const stats = await HTTPRequest.getRequest(this.buildPosSalesStatsUrl(), null)
      this.completedStats = '' + stats["no_of_completed"] + '';
      this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
      this.errorStats = '' + stats["no_of_error"] + '';
      this.invoiceStatus = stats["invoice_status"];
      this.lastRun = moment(stats["last_run"]);
      this.setProfileId(stats["setting_id"]);
    },
    changeSyncFilter(statusFilter, searchFilter, searchText) {
      if (searchText == null) {
        if (statusFilter == "0") {
          this.updateParameters('/')
        } else if (statusFilter == "Y") {
          this.updateParameters("?sync_status=Y")
        } else {
          this.updateParameters("?sync_status=N")
        }
      } else {
        if (statusFilter == "0") {
          this.updateParameters("?" + searchFilter + "=" + searchText)
        } else if (statusFilter == "Y") {
          this.updateParameters("?" + searchFilter + "=" + searchText + "&sync_status=Y")
        } else {
          this.updateParameters("?" + searchFilter + "=" + searchText + "&sync_status=N")
        }
      }
    },
    onSyncChange() {
      if (this.currentProfile == "branch_delta_sync_details") {
        this.changeSyncFilter(this.filterSyncStatus, 'profile', this.inputProfile)
      } else {
        this.changeSyncFilter(this.filterSyncStatus, 'code', this.inputTerminalName)
      }
    },
    loadPOSSalesDashboard: async function () {
      this.loadingPOSSalesDashboard = true;
      // if (isBranch) this.filters.siteId = secureStorage.getItem("defaultSiteId");
      this.formatDate();

      await this.fetchPosSalesStats();

      this.sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
      this.fetchTerminals();

      // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)
      this.loadingPOSSalesDashboard = false;
    },
    async loadEodDashboardPreference() {
      const userId = secureStorage.getItem("userId")
      const response = await HTTPRequest.getRequest(this.endPoint + "user_settings?module_name=eod_monitoring_dashboard&user_id=" + userId, null)
      const setting = response && response.data && response.data[0] ? response.data[0] : null

      if (!setting) {
        this.eodDashboardMode = 'new'
        this.eodDashboardSettingId = null
        return
      }

      let settingsJson = setting.settings_json
      if (typeof settingsJson === 'string') {
        settingsJson = JSON.parse(settingsJson || '{}')
      }

      this.eodDashboardMode = settingsJson && settingsJson.mode === 'new' ? 'new' : 'classic'
      this.eodDashboardSettingId = setting.id
    },
    async saveEodDashboardPreference(mode) {
      const userId = secureStorage.getItem("userId")
      const payload = {
        user_setting: {
          module_name: 'eod_monitoring_dashboard',
          user_id: userId,
          settings_json: JSON.stringify({ mode: mode })
        }
      }

      if (this.eodDashboardSettingId) {
        await HTTPRequest.putRequest(this.endPoint + "user_settings/" + this.eodDashboardSettingId, null, payload)
      } else {
        const response = await HTTPRequest.postRequest(this.endPoint + "user_settings", null, payload)
        this.eodDashboardSettingId = response.id
      }
    },
    async onEodDashboardModeChange(event) {
      const nextMode = event && event.target ? event.target.value : event
      this.eodDashboardMode = nextMode
      await this.saveEodDashboardPreference(nextMode)
    },
    applyNewEodFilters(nextFilters) {
      if (nextFilters.businessDate) {
        this.inputBusinessDate = moment(nextFilters.businessDate)
      }

      this.filters = {
        ...this.filters,
        businessDate: nextFilters.businessDate,
        siteId: nextFilters.siteId,
        terminalId: Array.isArray(nextFilters.terminalId) ? [...nextFilters.terminalId] : [],
        status: nextFilters.status,
        issueFilter: nextFilters.issueFilter,
        mismatchOnly: nextFilters.mismatchOnly
      }

      this.fetchTerminals(nextFilters.siteId)
      this.loadEodMonitoringDashboard()
    },
    handleNewEodSiteChange(siteId) {
      this.fetchTerminals(siteId, false)
    },
    async loadEodMonitoringDashboard() {
      if (!this.filters.businessDate) {
        this.completedStats = '0';
        this.pendingStats = '0';
        this.errorStats = '0';
        this.progressPercent = 0;
        this.eodSummary = {};
        return;
      }

      this.loadingPOSSalesDashboard = true;
      let url = `${this.endPoint}z_readings/pos_document_reconciliation_summary?business_date=${this.filters.businessDate}`;
      if (this.filters.siteId && this.filters.siteId !== '0') {
        url += `&site_id=${this.filters.siteId}`;
      }
      if (Array.isArray(this.filters.terminalId) && this.filters.terminalId.length > 0) {
        url += `&terminal_id=${this.filters.terminalId.join(',')}`;
      }

      const summary = await HTTPRequest.getRequest(url, null);
      this.eodSummary = summary || {};
      this.completedStats = `${summary.completed_count || 0}`;
      this.pendingStats = `${summary.pending_zread_count || summary.pending_count || 0}`;
      this.errorStats = `${summary.discrepancy_count || 0}`;
      const totalCount = Number(summary.total_terminal_count || summary.total_count || 0);
      const completedCount = Number(summary.completed_count || 0);
      this.progressPercent = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
      this.loadingPOSSalesDashboard = false;
    },
    async fetchTerminals(siteId = this.filters.siteId, resetSharedFilters = true) {
      if (resetSharedFilters) {
        if (this.currentProfile == 'eod_monitoring_dashboards') {
          this.filters.terminalId = []
        } else {
          this.filters.terminalId = '0'
        }
      }
      this.terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
    },
    formatDate() {
      if (this.inputBusinessDate != null) {
        this.filters.businessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')

      } else {
        this.filters.businessDate = ''
      }
      // this.filters.businessDate = this.formatBusinessDate
    }
  }
}
</script>

<style scoped>

.eod-sales-header {
  background-image: none !important;
  background: #f4f7fb !important;
}

.eod-sales-header::before,
.eod-sales-header::after {
  background-image: none !important;
}

.eod-summary-top-row {
  margin-bottom: 6px;
}

.eod-summary-bottom-row {
  margin-top: 6px;
}

.eod-hero-summary {
  min-height: 236px;
  background: #ffffff;
  border: 1px solid #dbe5f0;
  border-radius: 10px;
  color: #1f3d6c;
}

.eod-stat-overline {
  display: block;
  margin-bottom: 6px;
  color: #7c8eaa;
  font-size: 0.82rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.eod-hero-copy {
  color: #8aa0c2;
  font-size: 0.98rem;
  line-height: 1.45;
  max-width: 360px;
}

.eod-hero-heading {
  padding-right: 16px;
}

.eod-hero-chip {
  min-width: 150px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #f7f9fc;
  border: 1px solid #e6edf5;
}

.eod-hero-chip span {
  display: block;
  color: #7c8eaa;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
}

.eod-hero-chip strong {
  display: block;
  margin-top: 4px;
  color: #1f3d6c;
  font-size: 1.5rem;
  font-weight: 800;
}

.eod-hero-pills {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.eod-hero-pill {
  padding: 14px 16px;
  border-radius: 10px;
  background: #f7f9fc;
  border: 1px solid #e6edf5;
}

.eod-hero-pill span {
  display: block;
  color: #7c8eaa;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
}

.eod-hero-pill strong {
  display: block;
  margin-top: 6px;
  color: #1f3d6c;
  font-size: 1.35rem;
  font-weight: 800;
}

.eod-stat-card {
  min-height: 196px;
  border: 1px solid #dbe5f0;
  border-radius: 10px;
  background: #ffffff;
}

.eod-stat-card .card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
  min-height: 100%;
  padding: 22px 22px 18px;
}

.eod-top-stat-card {
  min-height: 236px;
}

.eod-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: #f7f9fc;
  color: #1f3d6c;
}

.eod-stat-card h2 {
  margin: 0;
  color: #1f3d6c;
  font-size: clamp(1.8rem, 2vw, 2.3rem);
  font-weight: 800;
  line-height: 1.1;
}

.eod-stat-copy {
  color: #8aa0c2;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
  max-width: 260px;
}

.is-pending-card {
  box-shadow: inset 0 4px 0 #f59e0b;
}

.is-complete-card {
  box-shadow: inset 0 4px 0 #22c55e;
}

.is-count-card {
  box-shadow: inset 0 4px 0 #3b82f6;
}

.is-gross-card {
  box-shadow: inset 0 4px 0 #ef4444;
}

.is-net-card {
  box-shadow: inset 0 4px 0 #eab308;
}

.eod-mode-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: 12px;
}

.eod-mode-label {
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}


.eod-progress-title,
.eod-progress-footer {
  color: #f5f5f5;
}

.eod-progress-card ::v-deep .ant-progress-inner {
  border-radius: 0 !important;
}

.eod-progress-card ::v-deep .ant-progress-text {
  color: #f5f5f5 !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.refresh-pos-data-btn {
  font-size: 20px;
}

.refresh-pos-data-btn label {
  display: flex;
  margin-bottom: 0;
  cursor: pointer;
}

@media (max-width: 991px) {
  .eod-hero-pills {
    grid-template-columns: 1fr;
  }

  .eod-hero-summary,
  .eod-stat-card {
    min-height: auto;
  }
}

.ant-calendar-picker, .input-group-append, .form-group {
  width: 100%;
}
</style>
